const aifT = (key, fallback) => (window.aifCartStrings && window.aifCartStrings[key]) || fallback;

if (!customElements.get('cart-upsell')) {
  class CartUpsell extends HTMLElement {
    connectedCallback() {
      if (!this._bound) {
        this.addEventListener('click', this.onClick.bind(this));
        this._bound = true;
      }
      if (this.hasAttribute('data-autoload') && this.dataset.productId && !this._loaded) {
        this._loaded = true;
        this.load(this.dataset.productId);
      }
    }

    async fetchSection(productId, intent) {
      const url = `${this.dataset.url}?section_id=cart-upsell&product_id=${productId}&limit=10&intent=${intent}`;
      const res = await fetch(url);
      if (!res.ok) return '';
      const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      const inner = doc.querySelector('.cart-upsell__inner');
      return inner && inner.querySelector('.cart-upsell__item') ? inner.innerHTML : '';
    }

    async load(productId) {
      if (!productId || !this.dataset.url) return;
      this.currentId = String(productId);
      try {
        let html = await this.fetchSection(productId, 'complementary');
        if (!html) html = await this.fetchSection(productId, 'related');
        if (this.currentId !== String(productId)) return;
        this.innerHTML = html;
      } catch (e) {
        this.innerHTML = '';
      }
    }

    parse(html, selector) {
      const el = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
      return el ? el.innerHTML : null;
    }

    async onClick(evt) {
      const btn = evt.target.closest('.cart-upsell__add');
      if (!btn || btn.disabled) return;
      evt.preventDefault();
      evt.stopPropagation();

      const mode = this.dataset.mode;
      const body = { items: [{ id: Number(btn.dataset.variantId), quantity: 1 }] };
      if (mode === 'notification') {
        body.sections = ['cart-notification-extras', 'cart-notification-button', 'cart-icon-bubble'];
      } else if (mode === 'mini') {
        body.sections = ['cart-icon-bubble'];
      }
      if (body.sections) body.sections_url = window.location.pathname;

      const original = btn.textContent;
      btn.disabled = true;
      btn.classList.add('is-loading');
      try {
        const res = await fetch(`${window.routes.cart_add_url}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body),
        });
        const data = await res.json();
        if (!res.ok || data.status) throw new Error(data.description || data.message);

        if (mode === 'page') {
          window.location.reload();
          return;
        }

        const s = data.sections || {};
        if (mode === 'notification') {
          const shipping = s['cart-notification-extras'] && this.parse(s['cart-notification-extras'], '.cart-extras__shipping');
          const shippingEl = document.querySelector('#cart-notification-extras .cart-extras__shipping');
          if (shippingEl && shipping !== null) shippingEl.innerHTML = shipping;
        }
        ['cart-notification-button', 'cart-icon-bubble'].forEach((id) => {
          const el = document.getElementById(id);
          const html = s[id] && this.parse(s[id], '.shopify-section');
          if (el && html !== null) el.innerHTML = html;
        });

        btn.textContent = aifT('added', '✓');
        btn.classList.add('is-added');
        if (mode === 'mini') document.dispatchEvent(new CustomEvent('cart-mini:refresh'));
      } catch (e) {
        btn.disabled = false;
        btn.textContent = aifT('failed', '!');
        setTimeout(() => (btn.textContent = original), 2000);
      } finally {
        btn.classList.remove('is-loading');
      }
    }
  }
  customElements.define('cart-upsell', CartUpsell);
}

/* Verzendbalk op de winkelwagenpagina bijwerken als aantallen veranderen */
(function () {
  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
  if (window.__fsbSubscribed) return;
  window.__fsbSubscribed = true;
  subscribe(PUB_SUB_EVENTS.cartUpdate, async () => {
    const targets = document.querySelectorAll('[data-fsb-refresh]');
    if (!targets.length) return;
    try {
      const res = await fetch(`${window.location.pathname}?section_id=free-shipping-bar`);
      const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      const section = doc.querySelector('.shopify-section');
      targets.forEach((el) => (el.innerHTML = section ? section.innerHTML : ''));
    } catch (e) {}
  });
})();
